import Createcollection from "../../../../../component/systemMaster/sponsorBank/collectionSponsorBank/createCollectionSponsorBank/createCollectionSponsorBank"

const Createcollections=()=>{
    return <Createcollection/>
};
export default Createcollections;